import React from 'react'
import ReactDOM from 'react-dom'
import { datadogRum } from '@datadog/browser-rum'

import { BrowserRouter as Router } from 'react-router-dom'
import { addAxiosInterceptor } from './Global/Utils/axiosInterceptor'

import App from './App'
import { LAUNCH_DARKLY, SERVICE_VERSION } from './constants'
import Auth0ContextProvider from './Global/Auth0Context'
import { GlobalProvider } from './Global/GlobalContext'
import '@truepill/react-capsule/dist/default-theme.css'
import { DrawerProvider } from './Global/DrawerContext'
import {
  AsyncProviderConfig,
  withLDProvider,
} from 'launchdarkly-react-client-sdk'
import { Five9ContextProvider } from './Global/Five9Context'

const LDConfig: AsyncProviderConfig = {
  clientSideID: LAUNCH_DARKLY.CLIENT_ID!,
  options: {
    application: {
      id: 'emr-v2-fe',
      version: SERVICE_VERSION,
    },
  },
}

if (process.env.REACT_APP_DD_TOKEN) {
  const ddHigherEnvironmentRegex =
    /https:\/\/(telehealth\.)?(truepill|stagingpill|falsepill)\.com/g
  const ddLocalDevRegex = /http:\/\/localhost:3002/g

  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_APP_ID || '',
    clientToken: process.env.REACT_APP_DD_TOKEN || '',
    env: process.env.REACT_APP_DD_ENV || 'local',
    service: process.env.REACT_APP_DD_SERVICE || 'emr-v2',
    site: process.env.REACT_APP_DD_SITE || 'us5.datadoghq.com',

    allowedTracingUrls: [
      {
        match:
          process.env.NODE_ENV === 'development'
            ? ddLocalDevRegex
            : ddHigherEnvironmentRegex,
        propagatorTypes: ['tracecontext'],
      },
    ],
    compressIntakeRequests: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackLongTasks: true,
    traceSampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
  })

  addAxiosInterceptor()
}

const wrappedApp = () => {
  return (
    <Router>
      <Auth0ContextProvider>
        <Five9ContextProvider>
          <DrawerProvider>
            <GlobalProvider>
              <App />
            </GlobalProvider>
          </DrawerProvider>
        </Five9ContextProvider>
      </Auth0ContextProvider>
    </Router>
  )
}

const LDWrappedApp = withLDProvider(LDConfig)(wrappedApp)

const rootElement = document.getElementById('root')
ReactDOM.render(
  <React.StrictMode>
    <LDWrappedApp />
  </React.StrictMode>,
  rootElement
)
